export default "__VITE_ASSET__XlRKFHoW__"